import * as React from "react";
import { SelectProps } from "antd/lib/select";
import { Select } from "antd";
import { groupListStore } from "Pages/Project/Groups/Stores/GroupsStore";
import { observer } from "mobx-react";
import { contactsStore } from "Stores/ContactsStore";
import { formatUsername } from "utils/formatUsername";
const Option = Select.Option;

interface AssigneeSelectProps extends SelectProps<string> {
  groupsWithOrganizations?: boolean;
}

export const AssigneeGroupSelect = observer(
  class AssigneeGroupSelect extends React.Component<AssigneeSelectProps> {
    get groupsList() {
      if (this.props.groupsWithOrganizations) {
        return groupListStore.forRights;
      } else {
        return groupListStore.groupsForAccessRights;
      }
    }
    get groupOptions() {
      return this.groupsList.map((item) => (
        <Option key={`@group${item.id}`} value={`@group${item.id}`}>
          {item.name}
        </Option>
      ));
    }

    get isLoading() {
      return groupListStore.state === "LOADING";
    }

    render() {
      return (
        <Select style={{ minWidth: 200 }} {...this.props} loading={this.isLoading}>
          {this.groupOptions}
        </Select>
      );
    }
  }
);

export const AssigneeUserSelect = observer(
  class AssigneeUserSelect extends React.Component<AssigneeSelectProps> {
    get userOptions() {
      return contactsStore.projectUsers
        .filter((item) => item.projectRole !== "INFO")
        .map((item) => (
          <Option key={`@user${item.id}`} value={`@user${item.id}`} disabled={!item.active}>
            {formatUsername({ firstName: item.firstName, surname: item.surname })}
          </Option>
        ));
    }

    get isLoading() {
      return contactsStore.state === "LOADING";
    }

    render() {
      return (
        <Select style={{ minWidth: 200 }} {...this.props} loading={this.isLoading}>
          {this.userOptions}
        </Select>
      );
    }
  }
);
